import type { IntegrationSpec } from '../../interfaces/integrationSpec';
import { IntegrationCategory } from '../../interfaces/integrationSpec';
import { integrationList } from './integrations';

export const KEY_PLACEHOLDER = `-----BEGIN PRIVATE KEY-----
MIIDdzCCAl+gAwIBAgIEAgAAuTANBgkqhkiG9w0BAQsFAD
...
-----END PRIVATE KEY-----
`;

export const CERTIFICATE_PLACEHOLDER = `-----BEGIN CERTIFICATE-----
MIIDdzCCAl+gAwIBAgIEAgAAuTANBgkqhkiG9w0BAQsFAD
...
-----END CERTIFICATE-----
`;

export const isSchemaFirstIntegration = (integration: { type: string }) => {
	const found = integrationList.find((i) => i.type === integration.type)!;
	return !!found.supportsSchemaConfiguration && !found.skipSchemaSelect;
};

export const isDashboardIntegration = (integration: { type: string }) => {
	const found = integrationList.find((i) => i.type === integration.type)!;
	return found.categories!.includes(IntegrationCategory.DASHBOARD);
};

export const isDBTCloudIntegration = (integration: { type: string }) =>
	integration.type === 'dbt';

export const isDataformIntegration = (integration: { type: string }) =>
	integration.type === 'dataform';

export const isTestableIntegration = (
	integrationSpec: IntegrationSpec,
	group?: number | string
) => {
	if (integrationSpec.type === 'marketplace') {
		return false;
	}

	const found = integrationSpec.value;

	return found.groupSettings?.[group || '']?.testable || found.testable;
};

export const isWarehouseOrDatabaseIntegration = (integration: {
	type: string;
}) => {
	const found = integrationList.find((i) => i.type === integration.type)!;
	return (
		found.categories?.includes(IntegrationCategory.WAREHOUSE) ||
		found.categories?.includes(IntegrationCategory.DATABASE)
	);
};

export const isQueryBlockIntegration = (spec: { type: string }) =>
	integrationList.find((i) => i.type === spec.type)?.supportsQueryBlocks;

export const isPreviewIntegration = (spec: { type: string }) =>
	integrationList.find((i) => i.type === spec.type)?.supportsPreviews;
